import { CustomLibraryListItem } from "features/library/components/CustomLibrary/CustomLibraryListItem";
import { Library, LibraryValue } from "features/library/types";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAllMapsListData } from "../../../../redux/index";
import DataLoader from "shared/components/data-loader";
import styled from "styled-components/macro";
import { CustomLibraryAddItem } from "./components/CustomLibraryAddItem";
import { CustomLibraryHeader } from "./components/CustomLibraryHeader";
import { CustomLibraryTopSection } from "./components/CustomLibraryTopSection";
import { List, AutoSizer } from "react-virtualized";

const CustomLibrary: React.FC = () => {
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);
	const id = searchParams?.get("id") || "";
	const isCreate = searchParams?.get("isCreate") || false;

	const libraries = useSelector((state: any) => state.libraries.customLibraries);
	const library: Library = getLibrary(id, libraries);

	const [filterValue, setFilterValue] = useState<string>("");

	const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFilterValue(e.target.value);
	};

	const filteredItems = library?.values
		?.filter((item: LibraryValue) => item?.name?.toUpperCase().includes(filterValue.toUpperCase()) || item?.description?.toUpperCase().includes(filterValue.toUpperCase()))
		?.sort((a, b) => {
			const nameComparison = a.name.localeCompare(b.name);
			if (nameComparison !== 0) return nameComparison;
			return a.description.localeCompare(b.description);
		});

	return (
		<DataLoader reduxActions={[getAllMapsListData] as any} disabledSpinner={true}>
			<LibraryContainer>
				<CustomLibraryHeader library={library} />
				<Body>
					<Wrapper>
						<CustomLibraryTopSection library={library} filterValue={filterValue} handleFilterChange={handleFilterChange} isCreate={isCreate} />
						<CustomLibraryAddItem libraryId={library?.id} isCreate={isCreate} />
						<LibraryItems>
							<div style={{ height: "calc(100vh - 420px)" }}>
								<AutoSizer>
									{({ height }) => (
										<List
											width={1200}
											height={height}
											rowCount={filteredItems?.length + 1}
											rowHeight={96}
											rowRenderer={({ index, style }: { index: number; style: React.CSSProperties }) => (
												<>
													{filteredItems[index] ? (
														<div key={filteredItems[index]?.id} style={style} id={`library-list${filteredItems[index]?.id}`}>
															<CustomLibraryListItem filteredItems={filteredItems} library={library} item={filteredItems[index]} />
														</div>
													) : (
														<EmptyCard />
													)}
												</>
											)}
										/>
									)}
								</AutoSizer>
							</div>
						</LibraryItems>
					</Wrapper>
				</Body>
			</LibraryContainer>
		</DataLoader>
	);
};

const getLibrary = (id: string, libraries: Library[]): Library => {
	if (["systems", "departments"].includes(id)) {
		return libraries?.find((library) => library?.name?.toLowerCase() === id && !library?.isCustom);
	}
	return libraries?.find((library) => {
		return library?.id === id && library?.isCustom;
	});
};

export default CustomLibrary;

const LibraryContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

const Body = styled.div`
	width: 100%;
	height: calc(100vh - 150px);
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: scroll;
`;

const Wrapper = styled.div`
	height: 100%;
	width: 1200px;
`;

const LibraryItems = styled.div`
	height: calc(100vh - 420px);
	width: 100%;
	margin-top: 16px;
`;

const EmptyCard = styled.div`
	background-color: #fff;
`;
